/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Quick Schedule Time Field
 *
 * @file QuickScheduleTimeField.jsx
 * @author Anuja Gaikwad
 * @since 2.0.3
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import TimeTextField from '../common/TimeTextField';
import Icon from '../icons/Icon';
import { QUICK_SCHEDULE_FORM_TIME_FIELD_CLASS } from './quickScheduleFormConstants';

const QuickScheduleTimeField = ({
  name,
  control,
  label,
  rules,
  parentApp,
  onChange: onChangeCallback
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <TimeTextField
        className={QUICK_SCHEDULE_FORM_TIME_FIELD_CLASS}
        label={label}
        value={field.value}
        onChange={(event) => {
          field.onChange(event.target.value);
          onChangeCallback?.(event.target.value);
        }}
        parentApp={parentApp}
        icons={{ clock: <Icon name="ClockIcon" /> }}
      />
    )}
  />
);

QuickScheduleTimeField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  parentApp: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

QuickScheduleTimeField.defaultProps = {
  rules: undefined,
  onChange: null
};

export default QuickScheduleTimeField;
